/**
 * Simple password hashing utility for client-side authentication
 * Note: This is still not as secure as server-side authentication,
 * but it provides better security than plain text passwords
 */

// Simple hash function (not cryptographically secure, but better than plain text)
function simpleHash(str: string): string {
  let hash = 0;
  if (str.length === 0) return hash.toString();
  
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  // Add some salt-like behavior
  const salted = str + 'portfolio_salt_2024';
  let saltedHash = 0;
  for (let i = 0; i < salted.length; i++) {
    const char = salted.charCodeAt(i);
    saltedHash = ((saltedHash << 5) - saltedHash) + char;
    saltedHash = saltedHash & saltedHash;
  }
  
  return Math.abs(hash + saltedHash).toString(16);
}

// Pre-computed hashes only — no plain-text passwords in repo
const HASHED_PASSWORDS = {
  portfolio: '888844ee',
  admin: '94cb932'
};

// Function to verify password
export function verifyPassword(inputPassword: string, passwordType: 'portfolio' | 'admin'): boolean {
  const inputHash = simpleHash(inputPassword);
  const expectedHash = HASHED_PASSWORDS[passwordType];
  
  // Use timing-safe comparison to prevent timing attacks
  return timingSafeEqual(inputHash, expectedHash);
}

// Timing-safe string comparison
function timingSafeEqual(a: string, b: string): boolean {
  if (a.length !== b.length) {
    return false;
  }
  
  let result = 0;
  for (let i = 0; i < a.length; i++) {
    result |= a.charCodeAt(i) ^ b.charCodeAt(i);
  }
  
  return result === 0;
}

// Function to generate hashes (for setup purposes)
export function generateHash(password: string): string {
  return simpleHash(password);
}

export const PASSWORD_HASHES = {
  portfolio: '888844ee',
  admin: '94cb932'
};
